import { createSelector } from 'reselect';
import { PREFERRED_DISHES } from '@shopDetails/model';
import getPropFromModule from './getPropFromModule';

const getPreferredDishes = createSelector(
  state => getPropFromModule(state, PREFERRED_DISHES),
  preferredDishes => preferredDishes || {},
);

export default getPreferredDishes;
